import React from "react";
import Select from "../../Select";
import type { DropdownInCellProps } from "./DropdownInCell.types";

const DropdownInCell: React.FC<DropdownInCellProps> = ({
  options,
  value = "",
  onChange,
}) => (
  <Select
    options={options}
    value={value}
    onChange={onChange}
    placeholder="Выбрать"
    ariaLabel="Выбрать значение"
    searchable={options.length > 5}
    fullWidth
  />
);

export default DropdownInCell;
